import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AllAnalyticsSubscriptionPlans.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useAllAnalyticsSubscriptionPlansQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAllAnalyticsSubscriptionPlansLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getAllAnalyticsSubscriptionPlansQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getAllAnalyticsSubscriptionPlans
  const [getAllAnalyticsSubscriptionPlansQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAllAnalyticsSubscriptionPlansQuery, ...result };
};

export const useAllAnalyticsSubscriptionPlansPromiseQuery = () => {
  const client = useApolloClient();

  const getAllAnalyticsSubscriptionPlans = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getAllAnalyticsSubscriptionPlans };
};
